import React from 'react';

import PingFangSemiBoldText from '../../../../../components/Text/PingFangSemiBoldText';
import RowCenter from '../../../../../components/Layout/RowCenter';
import RowBetween from '../../../../../components/Layout/RowBetween';
import Row from '../../../../../components/Layout/Row';
import { GrayApplePay, GreenApplePay, GrayCircularRightArrow, GreenCircularDownArrow } from '../../../../../assets/svg-image/payment-method';
import OpenSansSemiBoldText from '../../../../../components/Text/OpenSansSemiBoldText';

const ApplePay: React.FC<Props> = ({
  isEnglish,
  paymentMethod,
  setPaymentMethod,
  marginTop,
}) => {
  const type = 'applePay';

  return (
    <RowCenter style={{ marginTop }}>
      <RowBetween
        onClick={() => {
          if (paymentMethod === type) {
            setPaymentMethod(undefined);
          }
          else {
            setPaymentMethod(type);
          }
        }}
        style={{ width: 277, border: '1px solid', borderColor: paymentMethod === type ? '#00B595' : '#DEDEDE', borderRadius: 15, paddingTop: 10, paddingBottom: 10 }}
      >
        <Row style={{ marginLeft: 10 }}>
          <img src={paymentMethod === type ? GreenApplePay : GrayApplePay} style={{ width: 22, height: 13 }} />
          {
            isEnglish ? (
              <OpenSansSemiBoldText fontSize={16} color={paymentMethod === type ? '#00B595' : '#989898'} marginLeft={8} letterSpacing={1}>
                Apple pay
              </OpenSansSemiBoldText>
            ) : (
              <PingFangSemiBoldText fontSize={16} color={paymentMethod === type ? '#00B595' : '#989898'} marginLeft={8} letterSpacing={1}>
                苹果支付
              </PingFangSemiBoldText>
            )
          }
        </Row>

        <img src={paymentMethod === type ? GreenCircularDownArrow : GrayCircularRightArrow} style={{ width: 16, height: 16, marginRight: 10 }} />
      </RowBetween>
    </RowCenter>
  );
};

export interface Props {
  isEnglish: boolean;
  paymentMethod?: string;
  setPaymentMethod: (paymentMethod?: string) => void;
  marginTop?: number;
}

export default ApplePay;
